<app-layout-wrapper>
  <div class="container-fluid relative px-3">
    <div class="layout-spacing">
      <router-outlet></router-outlet>
    </div>
  </div>
</app-layout-wrapper>
